import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Box } from '@mui/material';
import { useZ3KDeviceState } from 'console/shared/hooks/device/z3k';
import { useDeviceState } from 'console/shared/contexts/device/state';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import * as S from '../../styles';
import { StatusLine } from '../status-line';
export const HeatingCircuitServiceView = memo(function HeatingCircuitServiceView(props) {
    const { z3k_circuit, sensor_name, is_fail, only_control_devices } = props;
    const { is_service_mode } = useDeviceState();
    const { is_legacy_device, z3k_config } = useDeviceConfig();
    const z3k_state = useZ3KDeviceState();
    const show_status_line = useMemo(() => z3k_config.server_settings?.show_control_devices_state || is_service_mode, [is_service_mode, z3k_config.server_settings]);
    const show_target_sensor = useMemo(() => (is_service_mode || is_legacy_device) && sensor_name != null, [is_service_mode, is_legacy_device, sensor_name]);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", rowGap: 0.5, children: [show_status_line && z3k_circuit && (_jsx(StatusLine, { z3k_config: z3k_config, heating_circuit: z3k_circuit, z3k_state: z3k_state, is_fail: is_fail, only_control_devices: only_control_devices })), show_target_sensor && (_jsx(S.TargetSensor, { "data-tooltip": "target-sensor", children: sensor_name }))] }));
});
